"use strict";module.exports=t=>`(min-width: ${t})`;
//# sourceMappingURL=index.js.map
